export default "__VITE_ASSET__97a9fbd8__"